import lib from 'google-libphonenumber';
import { addLead, concat, replaceNonNumbers, whitespaceToDashes } from './transform';

const phoneUtil = lib.PhoneNumberUtil.getInstance();

export const getAsString = (...args) => {
  const number = replaceNonNumbers(concat(args));
  return number ? addLead(number, '+') : '';
};

export const getAsObject = (...args) => {
  try {
    const phoneObject = phoneUtil.parse(getAsString(args));
    return phoneUtil.isValidNumber(phoneObject) ? phoneObject : null;
  } catch (err) {
    return null;
  }
};

export const getParts = (...args) => {
  const phoneObject = getAsObject(args);
  if (!phoneObject) {
    return null;
  }

  let country = '';
  let area = '';
  let phone = '';
  let number = '';

  try {
    const nsn = phoneUtil.getNationalSignificantNumber(phoneObject);
    const lndc = phoneUtil.getLengthOfNationalDestinationCode(phoneObject);
    country = phoneObject.getCountryCode().toString();
    area = lndc > 0 ? nsn.substring(0, lndc) : '';
    phone = getAsString(args).slice(country.length + 1);
    number = getAsString(args).replace(`+${country}${area}`, '');
  } catch {
    // Ignore
  }

  return { country, area, phone, number };
};

/*
 * @returns {Number} -1=UNKNOWN, 0=FIXED LINE, 1=MOBILE, 2=FIXED OR MOBILE, 3=TOLL-FREE, 4=PREMIUM, 5=SHARED, 6=VOIP, 7=PERSONAL, 8=PAGER, 9=UAN, 10=VOICE MAIL
 */
export const getType = (...args) => {
  const phoneObject = getAsObject(args);
  return !phoneObject ? -1 : phoneUtil.getNumberType(phoneObject);
};

export const format = (num, fmt) => {
  const phoneObject = getAsObject(num);
  return !phoneObject ? null : phoneUtil.format(phoneObject, fmt);
};

export const formatE164 = (...args) => {
  try {
    return phoneUtil.format(getAsObject(args), lib.PhoneNumberFormat.E164);
  } catch {
    return null;
  }
};

export const formatInternational = (...args) => {
  try {
    return phoneUtil.format(getAsObject(args), lib.PhoneNumberFormat.INTERNATIONAL);
  } catch {
    return null;
  }
};

export const formatNational = (...args) => {
  try {
    return phoneUtil.format(getAsObject(args), lib.PhoneNumberFormat.NATIONAL);
  } catch {
    return null;
  }
};

export const pickNumberOrShorthand = (numberOrShorthand, shorthandLength) => {
  const str = String(numberOrShorthand);
  const num = replaceNonNumbers(str);
  const int = parseInt(num, 10);

  if (!Number.isNaN(int) && num.length >= 9) {
    return formatE164(num);
  }

  return whitespaceToDashes(str).substring(0, shorthandLength || 11);
};

export default {
  getAsString,
  getAsObject,
  getParts,
  getType,
  formatE164,
  formatInternational,
  formatNational,
  pickNumberOrShorthand
};
